import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { flatten, mapMany, unique, intersectKeys, orderBy, groupBy, pipe, sum, innerJoin, any, firstMap } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface FilaSaldoCaja {
    Fecha: Date | string;
    Importe: number;
    IdCaja: number;
    NombreCaja: string;
    FormaPago: models.FormaPagoMovimientoCaja;
    TipoMovimiento: models.TipoMovimientoCajaView;
    TipoOrigen: models.OrigenMovimientoCaja;
    Cajas: models.ImporteCaja[];
}

/**Regresa un arreglo de FilaSaldoCaja que contienen la información del corte de caja */
export function GetFilasSaldoCajas(x: models.SaldosCaja): FilaSaldoCaja[] {

    let saldosCajas = x.SaldosIniciales;
    let movimientos = x.Movimientos;
    var res: FilaSaldoCaja[] = [];

    var movimientosOrdenados = orderBy(movimientos, x => x.Fecha);

    movimientosOrdenados.forEach(function (mov) {
        saldosCajas = AcumularSaldoCaja(saldosCajas, mov.IdCaja, mov.Importe);

        var newItem: FilaSaldoCaja = ({
            Fecha: mov.Fecha,
            FormaPago: mov.FormaPago,
            TipoMovimiento: mov.TipoMovimiento,
            IdCaja: mov.IdCaja,
            NombreCaja: mov.NombreCaja,
            Importe: mov.Importe,
            TipoOrigen: mov.TipoOrigen,
            Cajas: saldosCajas.map<models.ImporteCaja>(ca => ({ IdRegistro: ca.IdRegistro, Nombre: ca.Nombre, Saldo: ObtenerSaldoCaja(saldosCajas, ca.IdRegistro) }))
        });
        res = res.concat(newItem);
    });

    return res;
}

/** Obtiene el saldo de una caja en especifico de un arreglo de ImporteCaja */
export function ObtenerSaldoCaja(saldos: models.ImporteCaja[], id: number): number {
    var res = saldos.filter(x => x.IdRegistro == id).map(x => x.Saldo)[0];
    return res;
}

/**Acumula el valor de una caja en especifico en un arreglo de importeCaja y regresa el nuevo arreglo ya incrementado */
function AcumularSaldoCaja(saldos: models.ImporteCaja[], id: number, importe: number): models.ImporteCaja[] {
    var res = saldos.map(x => x.IdRegistro == id ? { ...x, Saldo: importe + x.Saldo } : x)
    return res;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/list/modales/model.tsx